<template>
    <div class="gantt">
        <!-- <v-divider></v-divider>  -->
        <div class="d-flex gantt-columns">
            <!-- <v-divider vertical></v-divider>  -->
            <div class="gantt-column">
                <div>ID</div>
                <div v-for="(task, t) in activeItems" :key="t" :class="openList.includes(task.id) ? '--opened' : '--closed'">
                    {{ task.id }}
                    <div v-if="openList.includes(task.id)">
                        <v-slide-y-transition>
                        <v-card class="--info-card" elevation="0">
                            <v-card-title>

                                Pedido {{ task.id}}
                            </v-card-title>
                            <v-card-text>
                                Olá!
                            </v-card-text>
                        </v-card>
                    </v-slide-y-transition>
                    </div>
                </div>
            </div>
            <!-- <div class="gantt-column" v-for="(info, key) in activeItems.info" :key="i">
                <div v-html="key"></div>
                <div v-for="(task, t) in info" :key="t" v-html="task.format"></div>

            </div> -->
            <div class="gantt-column" v-for="(key, indexKey) in activeHeaders" :key="indexKey">
                <div v-html="$t(`common.data.${key}`)"></div>
                <template v-for="(task, t) in activeItems" >
                    <!-- <div v-html="task.info[key]" :key="t"></div> -->
                    <div v-if="activeTypeHeaders[indexKey].type == 'text'" v-html="task.info[key]" :key="t" :class="openList.includes(task.id) ? '--opened' : '--closed'"></div>
                    <div v-if="activeTypeHeaders[indexKey].type == 'currency'" :key="t" :class="openList.includes(task.id) ? '--opened' : '--closed'">{{ $n(task.info[key], 'currency') }}</div>
                </template>

            </div>
            <!-- <div class="gantt-column" v-if="headers.includes(1)">
                <div>Status</div>
                <div v-for="(task, t) in activeItems" :key="t" v-html="task.status"></div>

            </div> -->
            <div class="gantt-dates">
                <div class="--month-label --fixed" id="monthLabelFixed">{{ dateLabel }}</div>
                <div class="gantt-column --date --relative" v-for="(day, i) in dateSet" :key="i">
                    <div>{{ day.day | dateDay }}
                        <div class="--month-label --m-l" :id="getIdOfMonth(day.day, i)"
                            v-if="isFirstDayOfMonth(day.day, i)">{{ day.day | dateMonth }}, {{ day.day | dateYear }}
                        </div>
                    </div>
                    <div class="day" :class="openList.includes(task.id) ? '--opened' : '--closed'" v-for="(task, t) in activeItems" :key="t" :style="into(t, day.day)"></div>

                </div>
            </div>
            <v-divider vertical></v-divider>
            <div class="gantt-column">
                <div></div>
                <div v-for="(task, t) in activeItems" :key="t" :class="openList.includes(task.id) ? '--opened' : '--closed'">
                    <v-btn x-small fab color="primary" outlined size="22" @click="open(task.id)">
                        <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                </div>
            </div>

        </div>
        <div v-if="!activeItems.length" class="mt-n3 pb-15" style="background: #fff; position: relative">
            <v-divider></v-divider>
            <div class="pa-3 text-center grey--text text-p">No data available</div>
            <v-divider></v-divider>
        </div>

        <!-- <v-divider></v-divider>  -->

    </div>
</template>
<script>
import Moment from 'moment';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);

export default {
    data: () => ({
        dateLabel: "",
        openList: [],
        filter: {
            from: null,
            to: null
        },
        labels: []
        // dateSet: []

    }),
    props: {
        dates: Array,
        headers: Array,
        queryText: String,
        items: Array,
        types: Array
    },
    mounted() {
        this.filter.from = this.dates[0]
        this.filter.to = this.dates[1]
        document
            .getElementsByClassName("gantt-dates")[0]
            .addEventListener("scroll", () => {
                const scrolled = document.getElementsByClassName("gantt-dates")[0]
                    .scrollLeft;
                this.checkLabel(scrolled)
            });

        this.loadMonthLabel()
    },
    watch: {
        dates: {
            deep: true,
            handler(val) {
                this.filter.from = val[0]
                this.filter.to = val[1]
                this.loadMonthLabel()
            }
        },
        '$i18n.locale': {
            deep: true,
            handler() {
                this.loadMonthLabel()
            }
        }
    },
    computed: {
        openedList(){
            const list = []
            this.openList.forEach((item) => {
                list.push(this.activeItems.indexOf(item.id))
            })
            return list
        },  
        activeHeaders(){
            return this.activeItems.length ? (Object.keys(this.activeItems[0].info)).filter((item, index) =>{ return this.headers.includes(index) } ) : []
        },
        activeTypeHeaders(){
            return this.activeHeaders.length ? this.types.filter((item) =>{ return this.activeHeaders.includes(item.name) } ) : []
        },
        activeItems() {
            const dateRange = moment.range(moment(this.filter.from), moment(this.filter.to))
            const dateResult = this.items.filter(item => {
                const itemRange = moment.range(moment(item.start), moment(item.end))
                return dateRange.intersect(itemRange)
            })
            
            return this.queryText.length ? dateResult.filter((data) =>  JSON.stringify(data).toLowerCase().indexOf(this.queryText.toLowerCase()) !== -1) : dateResult;
        },
        labelPosition() {
            const doc = document.getElementById('monthLabelFixed').getBoundingClientRect();
            return doc.left
        },

        dateSet() {
            const result = []
            const from = moment(this.filter.to, 'YYYY-MM-DD')
            const to = moment(this.filter.from, 'YYYY-MM-DD')
            const diff = from.diff(to, 'days')
            for (let i = -1; i < diff; i++) {

                let day = moment(this.filter.from, 'YYYY-MM-DD').add(i, 'days');
                result.push({ day: day.add(1, 'days'), tasks: [] })
            }
            return result
        }
    },
    methods: {
        open(id){
            const index = this.openList.indexOf(id)
            if(!this.openList.includes(id))
            this.openList.push(id)
            else
            this.openList.splice(index,1)
        }, 
        checkLabel(scroll) {
            let s = scroll + this.labelPosition + 10
            this.labels.forEach((label, i) => {
                if (s > label.left) {
                    this.dateLabel = label.text
                }
            })
        },
        offset(el) {
            const rect = el.getBoundingClientRect()
            return { top: rect.top, left: rect.left }
        },
        loadMonthLabel() {
            this.openList = []
            setTimeout(() => {
                const res = []
                const docs = document.getElementsByClassName('--m-l');
                for (var i = 0; i < docs.length; i++) {
                    let divOffset = this.offset(docs[i]);
                    res.push({ left: divOffset.left, text: docs[i].innerHTML, id: docs[i].id })
                }
                this.labels = res
                this.checkLabel(0)
            }, 300)
        },
        into(index, date) {
            let compareDate = date;
            let startDate = moment(this.activeItems[index].start, "YYYY-MM-DD");
            let endDate = moment(this.activeItems[index].end, "YYYY-MM-DD").add(1, 'day');
            return compareDate.isBetween(startDate, endDate) ? `background:${this.activeItems[index].color}` : ``;


        },
        isFirstDayOfMonth(date, index) {

            return moment(date, 'YYYY-MM-DD').date() == 1 || index == 0
        },
        getIdOfMonth(date, index) {
            return moment(date, 'YYYY-MM-DD').date() == 1 || index == 0 ? `dt-${moment(date, 'YYYY-MM-DD').format('YYYY-MM')}` : ''
        }
    }
}
</script>
<style lang="scss">
</style>
